module.exports = __webpack_public_path__ + "static/lato-latin-100italic.0a3a30f5.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-100italic.woff2
// module id = ./node_modules/typeface-lato/files/lato-latin-100italic.woff2
// module chunks = 17241999800008180000